import { I18n, Translate2 } from 'common'
import { CartProduct, IVehiclePriceChangedParts } from 'cart'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import miscellaneousVehicle from '../../../../src/features/search/Results/utils/miscellaneousVehicle'
import { Vehicle } from '../../../../src/store/models/Vehicles'
import { defaultTheme } from '../../../../src/theme'
import { Link } from '../../../../src/ui-components'
import { Hyperlink } from '../../../../src/ui-components/util/Hyperlink'
import styled from 'styled-components'
import { PriceChangeMsg } from '../../../../src/features/cart/components/AvailabilityErrors/components/PriceChangeMsg'
import { formatVehicleDisplayWithOutEngine } from 'src/helpers/utils'

interface VehicleWithPriceChangedProductsProps {
  vehicleWithParts: IVehiclePriceChangedParts
  removeCartFromOrder: (vehicle: Vehicle) => void
  removeItemFromCart: (item: IVehiclePriceChangedParts) => void
}

export const VehicleWithPriceChangedProducts = observer(
  ({
    vehicleWithParts,
    removeCartFromOrder,
    removeItemFromCart,
  }: VehicleWithPriceChangedProductsProps): ReactElement => {
    const { vehicle, parts } = vehicleWithParts
    const getCartName = (): string => {
      if (vehicle?.year?.id === miscellaneousVehicle?.year?.id)
        return 'MISCELLANEOUS'

      if (vehicle?.engine?.id) {
        return formatVehicleDisplayWithOutEngine(vehicle)
      }

      return ''
    }

    const vehicleStr = getCartName()

    const buildProductLink = (product: CartProduct, label?: string): Link => {
      return {
        action: () => {
          // TODO
        },
        text: label ?? `${product.description}, ${product.partNumber}`,
      }
    }

    return (
      <Container>
        <span>
          <VehicleTitle>
            {vehicleStr.replace(
              'MISCELLANEOUS',
              Translate2('miscellaneousText')
            )}
          </VehicleTitle>
          <Hyperlink
            action={() => {
              // remove vehicle from order
              removeCartFromOrder(vehicle)
            }}
            color={defaultTheme.colors.link}
          >
            <I18n name="removeCartFromOrder" style={{ fontSize: '14px' }} />
          </Hyperlink>
        </span>
        {parts.length > 0 && (
          <PriceChangedPartsWrapper>
            <PriceChangeMsg
              products={parts}
              buildProductLink={buildProductLink}
              vehicle={vehicle}
              hideLink={true}
              removeItemFromCart={removeItemFromCart}
              noMargin
            />
          </PriceChangedPartsWrapper>
        )}
      </Container>
    )
  }
)

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 15px;
  min-width: 0;
  max-width: 100%;
`

const PriceChangedPartsWrapper = styled.div`
  margin-top: 15px;
  min-width: 0;
  max-width: 100%;
`

const VehicleTitle = styled.span`
  align-items: center;
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  margin-right: 15px;
  color: ${(p) => p.theme.colors.almostBlack};
`
